import { C } from "../constants/colors";
import { Card, Btn, labelStyle, inputStyle } from "../components/ui";

export default function Onboarding({orgProfile}){
  const {obName,setObName,obIndustry,setObIndustry,obSize,setObSize,obLoading,createOrg}=orgProfile;
  return(
    <div style={{minHeight:"100vh",background:C.sand,fontFamily:"'Inter',system-ui,sans-serif",display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
      <div style={{maxWidth:480,width:"100%"}}>
        <div style={{textAlign:"center",marginBottom:32}}>
          <div style={{width:56,height:56,borderRadius:14,background:C.navy,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,color:C.white,fontSize:22,margin:"0 auto 16px"}}>WF</div>
          <h1 style={{fontSize:26,fontWeight:800,color:C.navy,marginBottom:8}}>Welcome to Waste Free</h1>
          <p style={{color:C.muted,fontSize:14,lineHeight:1.6}}>Let's set up your organization to get started with waste auditing.</p>
        </div>
        <Card>
          <div style={{marginBottom:18}}>
            <label style={labelStyle}>Organization Name</label>
            <input style={inputStyle} placeholder="e.g. Tahoe Grand Hotel" value={obName} onChange={e=>setObName(e.target.value)} autoFocus/>
          </div>
          <div style={{marginBottom:18}}>
            <label style={labelStyle}>Industry</label>
            <div style={{display:"flex",gap:12}}>
              {["hospitality","healthcare"].map(ind=>(
                <div key={ind} onClick={()=>setObIndustry(ind)}
                  style={{flex:1,padding:"14px 12px",borderRadius:10,cursor:"pointer",border:`2px solid ${obIndustry===ind?C.teal:C.border}`,background:obIndustry===ind?C.tealLight:C.white,textAlign:"center",fontWeight:600,color:obIndustry===ind?C.teal:C.muted,fontSize:14,textTransform:"capitalize",transition:"all 0.2s"}}>
                  {ind}
                </div>
              ))}
            </div>
          </div>
          <div style={{marginBottom:24}}>
            <label style={labelStyle}>Facility Size</label>
            <select style={inputStyle} value={obSize} onChange={e=>setObSize(e.target.value)}>
              <option value="">Select size</option>
              <option value="small">Small (&lt;50 employees)</option>
              <option value="medium">Medium (50–250 employees)</option>
              <option value="large">Large (250+ employees)</option>
            </select>
          </div>
          <Btn onClick={createOrg} disabled={!obName||!obIndustry||!obSize||obLoading} style={{width:"100%"}}>
            {obLoading?"Setting up…":"Create Organization →"}
          </Btn>
        </Card>
      </div>
    </div>
  );
}
